import React from "react";
import { Box, Grid, GridItem } from "@chakra-ui/react";
import { VeriDatePickerDaysViewProps } from "./VeriDatePickerDaysView.types";
import { useVeriDatePicker } from "../../VeriDatePickerContext";
import { shortDayNames } from "../../../../utils/dates";
import {
  getWeekDaysOfTheMonthInYear,
  selectedDateConsideringNegativeTimezoneOffset,
} from "../../utils";
import { DatePickerWeekDay } from "../../types";
import DayViewDayColumn from "./components/DayViewDayColumn/DayViewDayColumn";

const VeriDatePickerDaysView: React.FC<VeriDatePickerDaysViewProps> = ({
  ...rest
}) => {
  const datePicker = useVeriDatePicker();

  const [weeks, setWeeks] = React.useState<DatePickerWeekDay[][]>();
  //const _date = datePicker.date || new Date();
  const _date = selectedDateConsideringNegativeTimezoneOffset(
    datePicker.dateString,
  );

  React.useEffect(() => {
    const w = getWeekDaysOfTheMonthInYear(
      _date.getMonth(),
      _date.getFullYear(),
    );
    setWeeks(w);
  }, [datePicker.dateString]);

  return (
    <Box {...rest}>
      <Grid gridTemplateColumns={"repeat(7, 1fr)"}>
        {shortDayNames.map((shortDayName, index) => (
          <GridItem key={index}>
            <Box
              px={3}
              my={1}
              py={1}
              w={"100%"}
              textAlign={"center"}
              textStyle={"bodyRegularBold"}
            >
              {shortDayName}
            </Box>
          </GridItem>
        ))}
        {(weeks || []).map((week, index) => (
          <DayViewDayColumn currentDate={_date} key={index} days={week} />
        ))}
      </Grid>
    </Box>
  );
};

export default VeriDatePickerDaysView;
